module.exports = __webpack_public_path__ + "static/media/plussa-balls.20229850.svg";